var $ = require('jquery');

"use strict";

var PLUGIN_NAME = "socialShare";

var DEFAULTS = {
	services: {
		fb: 'http://www.facebook.com/sharer/sharer.php?u=${url}&t=${title}',
		twitter:  'http://twitter.com/?status=${title}',
		gplus: 'https://plus.google.com/share?url=${url}',
		linkedin: 'http://www.linkedin.com/shareArticle?mini=true&url=${url}&title=${title}'
	},
	eventSharePerformed: 'SOCIAL_SHARE_PERFORMED'
};

// The actual plugin constructor
function SocialShare(element, options) {
	this.element = element;
	this.$t = $(this.element);

	this.options = $.extend(true, {}, DEFAULTS, options);
	this._defaults = DEFAULTS;
	this._name = PLUGIN_NAME;
	this.initialise_();
}

/**
 *
 */
SocialShare.prototype.initialise_ = function() {

	this.type = null;
	this.pageUrl = null;
	this.pageName = null;

	this.getProperties_();
	this.buildShareStrings_();
	this.bindEvents_();
};

SocialShare.prototype.getProperties_ = function() {
	this.type = this.$t.data('socialNetwork');
	this.pageUrl = this.$t.data('urlShare') || String(document.URL);
	this.pageName = this.$t.data('titleShare') || document.title;

	this.pageName = this.pageName.replace('--', '');
};

SocialShare.prototype.buildShareStrings_ = function() {
	this.url = '';
	this.title = '';
	var str = '';

	switch (this.type) {
		case 'fb' :
			this.url = encodeURIComponent(this.pageUrl);
			this.title = encodeURIComponent(this.pageName);
			break;
		case 'twitter':
			str = '';
			str += (this.pageName !== '') ? this.pageName+': ' : '';
			str += this.pageUrl;
			this.title = encodeURIComponent(str);
			break;
		case 'gplus':
			this.url = encodeURIComponent(this.pageUrl);
			break;
		case 'linkedin':
			this.url = encodeURIComponent(this.pageUrl);
			this.title = encodeURIComponent(this.pageName);
			break;
		default:
			break;
	}
};

SocialShare.prototype.bindEvents_ = function() {
	var self_ = this;
	this.$t.on('click', function(e) {
		e.preventDefault();
		$(e.currentTarget).trigger(self_.options.eventSharePerformed, [$(e.currentTarget)]);
		window.open(self_.options.services[self_.type].replace(/\${url}/gi,self_.url).replace(/\${title}/gi,self_.title), 'social'+self_.type);
	});
};

/**
 * decide, which methods will be "public"
 */
var API = {
};

/**
 * plugin go live
 * @param value - first param - decides, which action shall be executed
 *         if object - apply plugin with these settings to an selector's elements, if they are clean (plugin not applied yet)
 *         if string && in API object - run method named as this value with all args[index > 0]
 * @return {*}
 */
$.fn[PLUGIN_NAME] = function(value) {
	var args = arguments;

	return this.each(function() {
		var $this = $(this);

		// get plugin instance
		var plugin = $this.data('plugin_' + PLUGIN_NAME);

		// if there's not, create one
		if (!plugin) {
			plugin = new SocialShare(this, value);
			$this.data('plugin_' + PLUGIN_NAME, plugin);
		}
		// if there is and first parameter is in predefined API methods, call it with rest of params
		else if (API[value]) {
			plugin[value].apply(plugin, Array.prototype.slice.call(args, 1));
		}
	});
};



// WEBPACK FOOTER //
// ./config/module-publish/resources/js/web/jquery.social-share.js